/**
 * Разблокировка альбомов (sets), у которых задано requiredRelationshipPoints ≤ текущий RP с персонажем.
 * @returns {{ mergedSetIds: string[], newlyUnlockedIds: string[] }}
 */
export function unlockSetsForRp(characterIdStr, relationshipRp, allSets, unlockedSetIds) {
  const cid = String(characterIdStr);
  const rp = Number(relationshipRp) || 0;
  const out = new Set((unlockedSetIds || []).map(String));
  const newlyUnlocked = [];

  for (const s of allSets || []) {
    const setChar = String(s.characterId?._id || s.characterId);
    if (setChar !== cid) continue;
    const req = s.requiredRelationshipPoints;
    if (req == null || req === '') continue;
    const n = Number(req);
    if (!Number.isFinite(n) || rp < n) continue;
    const sid = String(s._id);
    if (!out.has(sid)) {
      out.add(sid);
      newlyUnlocked.push(sid);
    }
  }

  return { mergedSetIds: [...out], newlyUnlockedIds: newlyUnlocked };
}

export function applyRelationshipBonus(characters, characterId, bonus) {
  const id = String(characterId);
  const b = Math.floor(Number(bonus) || 0);
  const list = Array.isArray(characters) ? characters.map((c) => ({ ...c })) : [];
  const idx = list.findIndex((c) => String(c.characterId) === id);
  if (idx >= 0) {
    list[idx] = {
      ...list[idx],
      relationship: (Number(list[idx].relationship) || 0) + b
    };
  } else {
    list.push({
      characterId: id,
      relationship: b,
      sessionNumber: 0
    });
  }
  return list;
}

export function getCharRow(characters, characterId) {
  const id = String(characterId);
  return (characters || []).find((c) => String(c.characterId) === id) || null;
}
